<template>
    <div class="cc-consents">
        <div class="cc-consents__main">{{ translations['By continuing you agree with terms of service and privacy policy.'] }} <a :href="config.consents.terms_of_use.link">{{ translations['Terms of service'] }}</a> {{ translations['and'] }} <a :href="config.consents.privacy_policy.link">{{ translations['privacy policy'] }}</a>.</div>
        <div class="cc-form-input">
            <input id="user.newsletter" type="checkbox" name="user.newsletter" class="cc-input cc-input--checkbox" :value="user.newsletter" @change="updateNewsletter">
            <label for="user.newsletter" class="cc-label cc-label--checkbox">{{ translations['Register for newsletter'] }}</label>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                config: state => state.config,
                user: state => state.user,
            }),
        },
        methods: {
            updateNewsletter: function (event) {
                this.$store.commit('SET_USER_NEWSLETTER', event.target.checked);
            },
        },
        name: 'Consents',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/consents";
</style>
